<template>
  <div class="label_demo">
    <div class="row">
      <SjLabel v-model="value">
        label switch theme1
      </SjLabel>

      <SjLabel theme="2" size="small" v-model="value">
        label switch theme2 small
      </SjLabel>

      <SjLabel theme="3" size="mini" v-model="value">
        label switch theme3 mini
      </SjLabel>

      <SjLabel theme="4" size="large" v-model="value">
        label switch theme4 large
      </SjLabel>

      <SjLabel theme="5" size="large" v-model="value">
        label switch theme5 large
      </SjLabel>

      <SjLabel v-model="value">
        ab
      </SjLabel>

      <SjLabel disabled :value="true">
        disabled
      </SjLabel>

      <SjLabel disabled :value="false">
        disabled
      </SjLabel>
    </div>

    <div class="row">
      <SjLabel type="display">
        label display theme1
      </SjLabel>

      <SjLabel type="display" theme="2" size="large">
        label display theme2 large
      </SjLabel>

      <SjLabel type="display" size="mini" style="width: 200px">
        <span class="long_label">label display theme1 long long long</span>
      </SjLabel>

      <SjLabel type="display" removable>
        label display theme1
      </SjLabel>

      <SjLabel type="display" theme="2" size="large" removable>
        label display theme2 large
      </SjLabel>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: false
    };
  }
};
</script>

<style scoped lang="less">
.row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > * {
    margin-right: 10px;
  }
  .long_label {
    .text-ellipsis();
  }
}
</style>
